/* eslint-disable import/no-anonymous-default-export */

const INITIAL_STATE = {
  data: null,
  payload: null,
  fetching: false,
  error: false,
  message: "",
  type: ""
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "UPLOAD_CSV":
      return { 
        ...state, 
        data: action.data, 
        fetching: true, 
        error: false, 
        message: "",
        type: "UPLOAD_CSV"
      };
    case "UPLOAD_CSV_SUCCESS":
      return { 
        ...state, 
        payload: action.payload, 
        fetching: false, 
        error: false,
        type: "UPLOAD_CSV_SUCCESS"
      };
    case "UPLOAD_CSV_ERROR":
      return { 
        ...state, 
        error: true, 
        fetching: false, 
        message: action.message,
        type: "UPLOAD_CSV_ERROR"
      };
    case "UPLOAD_CSV_RESET":
      return {
        ...INITIAL_STATE,
        type: "UPLOAD_CSV_RESET"
      };
    default:
      return state;
  }
};